import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Alert } from "../Alert";
import { useConfig } from "../../state/config-context";

export function DuplicateNotice({
  message,
  candidateId,
  basePath,
}: {
  message: string;
  candidateId: string | null;
  basePath: string;
}): ReactNode {
  const { t } = useConfig();
  return (
    <Alert tone="error">
      <p>{message}</p>
      {candidateId !== null ? (
        <p>
          <Link to={`${basePath}/${candidateId}`}>{t("crm.common.viewCandidate")}</Link>
        </p>
      ) : null}
    </Alert>
  );
}
